import { useContextStore } from "@/stores/context";

const DomHandler = {
    /**
     * Gets HTML element
     */
    getHtml() {
        return document.querySelector('html');
    },

    /**
     * Scrolls page to top
     * @returns 
     */
    scrollTop() {
        setTimeout(() => {
            window.scrollTo({
            top: 0,
            behavior: 'smooth',
            })
        }, 100);
    },

    /**
     * Scrolls page to bottom
     */
    scrollDown() {
        setTimeout(() => {
            window.scrollTo({
                top: document.body.scrollHeight,
                behavior: 'smooth',
            });
        }, 100);
    },

    /**
     * Enables page scroll
     */
    enableScroll() {
        this.getHtml().style.overflowY = 'scroll';
    },

    /**
     * Disables page scroll
     */
    disableScroll() {
        this.getHtml().style.overflowY = 'hidden';
    },

    setHtmlStyle() {
        const context = useContextStore();
        const root = document.documentElement;
        if (context.isDarkMode) {
            root.style.setProperty('--scrollbar-track-color', '#1e2a3a');
            root.style.setProperty('--scrollbar-thumb-color', '#3a4b61');
        } else {
            root.style.setProperty('--scrollbar-track-color', '#f0f0f0');
            root.style.setProperty('--scrollbar-thumb-color', '#a0a0a0');
        }
    }
}

export default DomHandler;